import { BarChart2, MessageSquare, RefreshCcw, Users } from 'lucide-react';
import { useStore } from '../../store/useStore';

const STAGE_LABELS = ['新询盘', '已报价', '谈判中', '待付款', '已成交'];
const PLATFORM_LABELS = {
  telegram: 'Telegram',
  whatsapp: 'WhatsApp',
  wecom: '企业微信',
  teams: 'Teams',
  email: 'Email',
  facebook: 'Facebook',
  instagram: 'Instagram',
};
const STATUS_LABELS = {
  open: '打开',
  closed: '已关闭',
};

const fmt = (value) => Number(value || 0).toLocaleString('zh-CN');

export default function AnalyticsView() {
  const { analytics, analyticsLoading, error, loadAnalytics } = useStore();
  const maxPlatform = Math.max(...(analytics?.platforms || []).map(item => item.value), 1);
  const maxStatus = Math.max(...(analytics?.statuses || []).map(item => item.value), 1);
  const maxStage = Math.max(...(analytics?.stages || []).map(item => item.value), 1);

  return (
    <main className="analytics-view">
      <div className="analytics-header">
        <div>
          <div className="analytics-title">数据</div>
          <div className="analytics-subtitle">客户、会话和任务概览</div>
        </div>
        <button className="icon-btn" onClick={loadAnalytics} title="刷新数据" disabled={analyticsLoading}>
          <RefreshCcw size={16} />
        </button>
      </div>

      {error && <div className="tasks-error">{error}</div>}
      {analyticsLoading && !analytics && <div className="analytics-empty">正在加载数据...</div>}

      {analytics && (
        <div className="analytics-content">
          <div className="metric-grid">
            <Metric icon={Users} label="客户" value={analytics.contacts} />
            <Metric icon={MessageSquare} label="会话" value={analytics.conversations} />
            <Metric icon={MessageSquare} label="打开会话" value={analytics.openConversations} />
            <Metric icon={MessageSquare} label="已关闭" value={analytics.closedConversations} />
            <Metric icon={BarChart2} label="消息" value={analytics.messages} />
            <Metric icon={BarChart2} label="未读" value={analytics.unread} />
            <Metric icon={BarChart2} label="待办任务" value={analytics.tasks} />
            <Metric icon={BarChart2} label="订单记录" value={analytics.orders} />
          </div>

          <div className="analytics-panels">
            <section className="analytics-panel">
              <div className="analytics-panel-title">平台会话</div>
              {(analytics.platforms || []).map(item => (
                <BarRow
                  key={item.name}
                  label={PLATFORM_LABELS[item.name] || item.name}
                  value={item.value}
                  percent={(item.value || 0) / maxPlatform * 100}
                />
              ))}
            </section>

            <section className="analytics-panel">
              <div className="analytics-panel-title">会话状态</div>
              {(analytics.statuses || []).map(item => (
                <BarRow
                  key={item.name}
                  label={STATUS_LABELS[item.name] || item.name}
                  value={item.value}
                  percent={(item.value || 0) / maxStatus * 100}
                />
              ))}
            </section>

            <section className="analytics-panel">
              <div className="analytics-panel-title">客户阶段</div>
              {(analytics.stages || []).map(item => (
                <BarRow
                  key={item.name}
                  label={STAGE_LABELS[Number(item.name)] || '未设置'}
                  value={item.value}
                  percent={(item.value || 0) / maxStage * 100}
                />
              ))}
            </section>

            <section className="analytics-panel">
              <div className="analytics-panel-title">收发消息</div>
              <div className="direction-grid">
                <div>
                  <span>收到</span>
                  <strong>{fmt(analytics.inboundMessages)}</strong>
                </div>
                <div>
                  <span>发出</span>
                  <strong>{fmt(analytics.outboundMessages)}</strong>
                </div>
              </div>
            </section>

            <section className="analytics-panel">
              <div className="analytics-panel-title">活跃客户</div>
              {(analytics.topContacts || []).map(contact => (
                <div key={contact.contactId} className="top-contact-row">
                  <div>
                    <div className="top-contact-name">{contact.name}</div>
                    <div className="top-contact-company">{contact.company || '未填写公司'}</div>
                  </div>
                  <span>{fmt(contact.messages)}</span>
                </div>
              ))}
            </section>
          </div>
        </div>
      )}
    </main>
  );
}

function Metric({ icon: Icon, label, value }) {
  return (
    <div className="metric-card">
      <div className="metric-icon"><Icon size={16} /></div>
      <div>
        <div className="metric-label">{label}</div>
        <div className="metric-value">{fmt(value)}</div>
      </div>
    </div>
  );
}

function BarRow({ label, value, percent }) {
  return (
    <div className="bar-row">
      <div className="bar-row-top">
        <span>{label}</span>
        <strong>{fmt(value)}</strong>
      </div>
      <div className="bar-track">
        <div className="bar-fill" style={{ width: `${Math.max(percent, 4)}%` }} />
      </div>
    </div>
  );
}
